export enum SDCardErrorType {
    Full = 1,
    Unformatted = 2,
    ReadWriteError = 3,
    RecordingDisabled = 4,
    Loss = 5,
    NotIdentifiedOrNotMounted = 6,
    PartitioningError = 7,
    CapacityLimitExceeded = 8 
}